<script setup lang="ts">
/**
 * What sets a lesson apart from the weekly one: moved, or an extra.
 *
 * A lesson moved into another week is kept apart from that week's own lesson
 * by the same flag an extra lesson carries, so the move is read first.
 */
import { computed } from 'vue'

const props = defineProps<{
  lesson: {
    is_moved: boolean
    is_one_off: boolean
    moved_from: string | null
  }
}>()

const label = computed(() => {
  if (props.lesson.is_moved) return props.lesson.moved_from ? `Moved from ${props.lesson.moved_from}` : 'Moved'
  if (props.lesson.is_one_off) return 'Extra lesson'
  return null
})
</script>

<template>
  <span v-if="label" class="rounded-full bg-purple-50 px-2 py-0.5 text-xs text-purple-700">{{ label }}</span>
</template>
